
  import { defineComponent, onUnmounted } from 'vue';
  import { templates } from '@/ui/auth/templates';
  import { Template } from '@/entities/template/model';
  import { CLICK_EVENTS, trackClick } from '@/services/activityTracker/activityTrackerHelper';
  import { Tag } from '@/ui/components/Tag';
  import { Loading } from '@/ui/components/Loading';
  import { useTemplateList } from '@/ui/concerns/checklist/useTemplateList';
  import { useTemplateLibraryStore } from '@/stores/checklist/templateLibrary';
  import { storeToRefs } from 'pinia';

  interface TemplateListProps {
    isFetching: boolean;
  }

  export default defineComponent<TemplateListProps>({
    name: 'NewTemplateList',
    components: { Tag, Loading },
    props: ['isFetching'],
    setup() {
      const { activeTemplate } = storeToRefs(useTemplateLibraryStore());
      const { setActiveTemplate } = useTemplateList();
      const onClick = (template: Template) => {
        trackClick(CLICK_EVENTS.PREVIEW_TEMPLATE, { label: template.title });

        setActiveTemplate(template.id);
      };
      const isActive = (id: number) => activeTemplate.value?.id === id;

      onUnmounted(() => {
        templates.value = [];
      });

      return {
        activeTemplate,
        isActive,
        templates,
        onClick,
      };
    },
  });
